import { jsPDF } from "jspdf";
import { createPdfDocumentSession } from "../pdf-preview/document-session";

/** Capture exactly the rendered saved snapshot, never recompute prices for export. */
export async function downloadQuotePdf(source: HTMLElement, quoteNo: string) {
  const session = await createPdfDocumentSession(source, 1.5);
  try {
    const pdf = new jsPDF("p", "pt", "a4", true);
    for (let index = 0; index < session.pages.length; index++) {
      const canvas = await session.capture(session.pages[index]);
      const width = pdf.internal.pageSize.getWidth();
      const height = pdf.internal.pageSize.getHeight();
      const scale = Math.min(width / canvas.width, height / canvas.height);
      if (index) pdf.addPage();
      pdf.addImage(canvas.toDataURL("image/png"), "PNG", (width - canvas.width * scale) / 2,
        (height - canvas.height * scale) / 2, canvas.width * scale, canvas.height * scale, "", "FAST");
      canvas.width = 0; canvas.height = 0;
    }
    pdf.save(`easybar_quote_${quoteNo}.pdf`);
  } finally { session.dispose(); }
}
